/**
 * ProgramToggle — small segmented control used by the Grids/Rules admin screens
 * to switch program (RTL / GUC) or rule type. Teal active pill, eastviewos style.
 */
import Box from "@mui/material/Box";
import { teal } from "../../theme/colors";

export default function ProgramToggle({ value, options, onChange, size = "sm" }) {
  const py = size === "sm" ? 0.4 : 0.6;
  return (
    <Box
      sx={{
        display: "inline-flex",
        flexWrap: "wrap",
        gap: 0.5,
        p: 0.5,
        bgcolor: "#f1f5f9",
        borderRadius: 2,
      }}
    >
      {options.map((opt) => {
        const val = typeof opt === "string" ? opt : opt.value;
        const label = typeof opt === "string" ? opt : opt.label;
        const active = val === value;
        return (
          <Box
            key={val}
            component="button"
            type="button"
            onClick={() => onChange(val)}
            sx={{
              appearance: "none",
              border: "none",
              cursor: "pointer",
              px: 1.5,
              py,
              borderRadius: 1.5,
              fontFamily: "Inter, sans-serif",
              fontSize: 12,
              fontWeight: active ? 700 : 500,
              color: active ? "#fff" : "#475569",
              bgcolor: active ? teal[700] : "transparent",
              boxShadow: active ? "0 1px 2px rgba(20,80,107,0.3)" : "none",
              transition: "background 0.12s, color 0.12s",
              whiteSpace: "nowrap",
              "&:hover": { bgcolor: active ? teal[700] : "#e2e8f0" },
            }}
          >
            {label}
          </Box>
        );
      })}
    </Box>
  );
}
